import { rule } from '../../domain/badge-composition-rule.js';

/**
 * @param {BadgeComposition} composition
 * @returns {BadgeCompositionRule[]}
 */
export const headerRules = composition => {
  const { variantIs } = composition.checkers;

  return [
    rule('header')
      .when(variantIs('header'))
      .set(() => ({
        constraints: {
          alwaysMaximized: true,
        },
        container: {
          type: 'pill',
        },
        parts: {
          aubySeal: {
            offsetType: 'xs',
            offsetBottom: true,
          },
          headerText: {
            type: 'minimal',
            minimalOption: "only-brandCount",
            center: true,
          },
          contents: {
            present: false,
          },
          carousel: {
            location: 'header',
            size: 'xs'
          }
        }
      }))
  ];
};
